export default "__VITE_ASSET__TJpcKF00__"